/**
 * How an entry was paid is a TAG, not an account.
 *
 * INVARIANT (AGENTS.md §1): there are no accounts and no balances. "Cash or
 * card?" is answerable because it is recorded on the entry, but nothing here
 * ever computes what is left in a wallet. The app says where money went, never
 * how much you have.
 *
 * The methods themselves are no longer a fixed enum: each household keeps its
 * own flat, editable list (the `payment_means` table). There is deliberately no
 * type or grouping over them — a list of names is the whole model.
 */
export const ENTRY_TYPES = ['EXPENSE', 'INCOME'];
/** How an entry got into the system. `OCR` is provenance only — no image is kept. */
export const ENTRY_SOURCES = ['MANUAL', 'OCR', 'IMPORT', 'RECURRING'];
export const MEMBER_ROLES = ['OWNER', 'ADULT', 'VIEWER'];
export function canEditCategories(role) {
    return role === 'OWNER';
}
export function canCreateEntries(role) {
    return role === 'OWNER' || role === 'ADULT';
}
/** Units a line item can be measured in. Deliberately small — extend when a real receipt demands it. */
export const ITEM_UNITS = ['PCS', 'KG', 'G', 'L', 'ML'];
//# sourceMappingURL=payment.js.map